import VehicleIcon from "../images/dashboard/vehicle_icon.svg";
import DriverIcon from "../images/dashboard/drivers_icon.svg";
import RouteIcon from "../images/dashboard/routes_icon.svg";
import StopIcon from "../images/dashboard/stops_icon.svg";
import SiteIcon from "../images/dashboard/sites_icon.svg";
import AlertIcon from "../images/dashboard/alerts_icon.svg";
import ActiveIcon from "../images/dashboard/active_vehicle.svg";
import InactiveIcon from "../images/dashboard/inactive_vehicle.svg";
import DeadIcon from "../images/dashboard/dead_vehicles.svg";
import AlertVehicleIcon from "../images/dashboard/alert_vehicle.svg";
import AlertUserIcon from "../images/dashboard/alert_user.svg";
import AlertDueDateIcon from "../images/dashboard/alert_due.svg";


export const DASHBOARD = "dashboard"
// Modified to accept translation function as parameter
export const generateCardData = (overview = {}, t) => [
  {
    id: 1,
    title: t('Vehicles'),
    number: overview.vehicles || 0,
    path: "/Vehicle",
    icon: <img src={VehicleIcon} alt="Vehicle" className="icon" />,
    extraInfo: [
      {
        icon: <img src={ActiveIcon} alt="Active Vehicle" className="Active icon" />,
        number: overview.activeVehicles || 0,
        label: t('activeVehicles'),
        title: t('activeVehicles')
      },
      {
        icon: <img src={InactiveIcon} alt="Inactive Vehicle" className="Inactive icon" />,
        number: overview.inactiveVehicles || 0,
        label: t('inactiveVehicles'),
        title: t('inactiveVehicles')
      },
      // {
      //   icon: <img src={DeadIcon} alt="Dead Vehicle" className="Dead icon" />,
      //   number: overview.deadVehicles || 0,
      //   label: t('deadVehicles'),
      //   title: t('deadVehicles')
      // }
    ]
  },
  {
    id: 2,
    title: t('Alerts'),
    number: overview.totalAlerts || 0,
    path: "/alert",
    icon: <img src={AlertIcon} alt="Alert" className="icon" />,
    extraInfo: [
      {
        icon: <img src={AlertVehicleIcon} alt="Alert Vehicle" className="Active icon" />,
        number: overview.vehicleAlerts || 0,
        label: t('vehicleAlerts'),
        title: t('vehicleAlerts')
      },
      {
        icon: <img src={AlertUserIcon} alt="Alert User" className="Active icon" />,
        number: overview.userAlerts || 0,
        label: t('userAlerts'),
        title: t('userAlerts')
      },
      {
        icon: <img src={AlertDueDateIcon} alt="Alert DueDate" className="Active icon" />,
        number: overview.expiryAlerts || 0,
        label: t('expiryAlerts'),
        title: t('expiryAlerts')
      }
    ]
  },
  {
    id: 3,
    title: t('Routes'),
    number: overview.routes || 0,
    path: "/route",
    icon: <img src={RouteIcon} alt="Route" className="icon" />
  },
  {
    id: 4,
    title: t('Drivers'),
    number: overview.drivers || 0,
    path: "/driver",
    icon: <img src={DriverIcon} alt="Driver" className="icon" />
  },
  {
    id: 5,
    title: t('Stops'),
    number: overview.stops || 0,
    path: "/stop",
    icon: <img src={StopIcon} alt="Stop" className="icon" />
  },
  {
    id: 6,
    title: t('Sites'),
    number: overview.sites || 0,
    path: "/site",
    icon: <img src={SiteIcon} alt="Site" className="icon" />
  }
];

export const ACTIONS_COLUMN_ID = '__actions__';